import { useState } from "react";
import { methodSteps } from "../../../mocks/starTracker";

export default function Guide() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="guide" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-10 px-4 md:px-6 lg:grid-cols-12 lg:px-10">
        <div className="lg:col-span-5">
          <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-700">
            <i className="ri-compass-3-line text-base"></i>
            追瓜指南
          </span>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            吃瓜不迷路：<br className="hidden md:block" />一套编辑部同款追踪方法
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            我们不做“情绪搬运工”。把追一个事件的底层逻辑沉淀成四步方法，任何人都能据此看懂舆论走向、判断信息可信度。
          </p>
          <div className="mt-6 overflow-hidden rounded-lg bg-foreground-950 p-6">
            <p className="font-heading text-lg font-bold text-accent-300">编辑部的底线</p>
            <p className="mt-2 text-sm leading-relaxed text-background-200/90">
              反转是常态，静默是信号。在权威结论出现前，我们只用公开、可交叉印证的信息说话，不为点击量放大无法核实的私密细节。
            </p>
          </div>
        </div>

        <div className="lg:col-span-7">
          <ol className="space-y-3">
            {methodSteps.map((m, i) => (
              <li
                key={m.step}
                className={`overflow-hidden rounded-lg ring-1 transition-colors ${
                  open === i ? "bg-background-50 ring-background-300" : "bg-background-50 ring-background-200"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(open === i ? null : i)}
                  aria-expanded={open === i}
                  className="flex w-full items-center gap-4 px-5 py-4 text-left"
                >
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 font-label text-sm font-bold text-primary-700">
                    {m.step}
                  </span>
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                    <i className={`${m.icon} text-lg`}></i>
                  </span>
                  <span className="flex-1 font-heading text-base font-bold text-foreground-950">{m.title}</span>
                  <i
                    className={`ri-arrow-down-s-line text-xl text-secondary-500 transition-transform ${open === i ? "rotate-180" : ""}`}
                  ></i>
                </button>
                {open === i && (
                  <p className="border-t border-background-200 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                    {m.text}
                  </p>
                )}
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}